module.exports = __webpack_public_path__ + "assets/1c6d39cd43483c2d7f8affc6452e182e.png";